import styled from "@emotion/styled";

export const InfoSearchWrapper = styled.div`
  padding: 13px 8px 0px 8px;
`;
